import React from 'react';
import { useSelector } from 'react-redux';

const Terms = () => {
  const language = useSelector((state) => state.language);

  return (
    <div className={`min-h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-20 px-4`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {language === "ar" ? "شروط الخدمة" : language === "fr" ? "Conditions d'utilisation" : "Terms of Service"}
        </h1>

        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6 text-gray-700">
          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "قبول الشروط" : language === "fr" ? "Acceptation des conditions" : "Acceptance of Terms"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "باستخدام RAQIB، فإنك توافق على قبول جميع الشروط والأحكام المنصوص عليها في هذه الاتفاقية."
                : language === "fr"
                ? "En utilisant RAQIB, vous acceptez tous les termes et conditions énoncés dans cet accord."
                : "By using RAQIB, you agree to accept all terms and conditions set forth in this agreement."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "الاستخدام المصرح به" : language === "fr" ? "Utilisation autorisée" : "Authorized Use"}
            </h2>
            <p className="leading-relaxed mb-3">
              {language === "ar"
                ? "أنت توافق على استخدام RAQIB فقط للأغراض المشروعة وبطريقة تتوافق مع القوانين المعمول بها."
                : language === "fr"
                ? "Vous acceptez d'utiliser RAQIB uniquement à des fins légitimes et conformément à toutes les lois applicables."
                : "You agree to use RAQIB only for lawful purposes and in a manner consistent with applicable laws."}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{language === "ar" ? "عدم انتهاك حقوق الآخرين" : language === "fr" ? "De ne pas violer les droits des autres" : "Not violating anyone's rights"}</li>
              <li>{language === "ar" ? "عدم نشر محتوى ضار" : language === "fr" ? "Ne pas publier de contenu nuisible" : "Not posting harmful content"}</li>
              <li>{language === "ar" ? "عدم محاولة الوصول غير المصرح به" : language === "fr" ? "Ne pas tenter d'accès non autorisé" : "Not attempting unauthorized access"}</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "الخدمات والميزات" : language === "fr" ? "Services et fonctionnalités" : "Services and Features"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "RAQIB توفر الخدمات 'كما هي' و 'كما متاحة'. نحن لا نقدم أي ضمانات أخرى سواء صراحة أو ضمنية."
                : language === "fr"
                ? "RAQIB fournit les services 'tels quels' et 'selon la disponibilité'. Nous ne donnons aucune autre garantie."
                : "RAQIB provides services 'as is' and 'as available'. We provide no other warranties, express or implied."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "المسؤولية والقيود" : language === "fr" ? "Responsabilité et limitations" : "Liability and Limitations"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "في أي حال من الأحوال، لن تكون RAQIB مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية."
                : language === "fr"
                ? "En aucun cas, RAQIB ne sera responsable de tout dommage indirect ou accessoire."
                : "In no event shall RAQIB be liable for any indirect, incidental, special, or consequential damages."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "تسديد الدفع" : language === "fr" ? "Paiement" : "Payment Terms"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "بموجب هذه الاتفاقية، توافق على دفع جميع الرسوم والنفقات المطبقة التي تكبدتها المحفوظة."
                : language === "fr"
                ? "Vous acceptez de payer tous les frais applicables incombés dans votre plan d'abonnement."
                : "You agree to pay all applicable fees incurred in your subscription plan."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "الإنهاء" : language === "fr" ? "Résiliation" : "Termination"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "RAQIB تحتفظ بالحق في إنهاء حسابك إذا انتهكت هذه الشروط في أي وقت."
                : language === "fr"
                ? "RAQIB se réserve le droit de résilier votre compte si vous violez ces termes à tout moment."
                : "RAQIB reserves the right to terminate your account if you violate these terms at any time."}
            </p>
          </div>

          <div className="bg-teal-50 border-l-4 border-teal-500 p-4 rounded">
            <p className="text-sm text-gray-700">
              {language === "ar"
                ? "آخر تحديث: مارس 2026. إذا كان لديك أي أسئلة حول شروط الخدمة هذه، يرجى التواصل معنا على legal@raqibapp.com"
                : language === "fr"
                ? "Dernière mise à jour: mars 2026. Si vous avez des questions sur ces conditions d'utilisation, veuillez nous contacter à legal@raqibapp.com"
                : "Last updated: March 2026. If you have any questions about these terms, please contact us at legal@raqibapp.com"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
